import type { Coworker } from "./coworkers";

/**
 * SEARCHING THE COWORKERS WINDOW. Pure, so the rule is tested without a screen.
 *
 * The route returns every coworker at once, sorted by last name, with no search or
 * paging of its own (`api/src/routes/users/getMyAssociates`). The filtering is
 * therefore done here, in the browser, as the bearer types: a few hundred names at
 * most.
 */

/** Lower case, accents removed: « Léa » and « lea » are typed the same, standing up. */
function fold(text: string): string {
  return text
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();
}

/**
 * The coworkers whose name or company contains EVERY word typed, in any order:
 * « dupont jean », « jean dup » and « acme » all find Jean DUPONT of Acme.
 *
 * ⚠️ THOSE WHO CANNOT BE CHOSEN COME LAST, still listed. Someone looking for a
 * colleague already registered must find them and read why, otherwise they add the
 * same person by hand. Within each group, the route's order (last name) is kept.
 */
export function searchCoworkers(
  coworkers: ReadonlyArray<Coworker>,
  query: string,
  taken: (coworker: Coworker) => boolean,
): Coworker[] {
  const words = fold(query).split(/\s+/).filter(Boolean);
  const found = coworkers.filter((c) => {
    const said = fold(`${c.name} ${c.company}`);
    return words.every((word) => said.includes(word));
  });
  return [
    ...found.filter((c) => !taken(c)),
    ...found.filter((c) => taken(c)),
  ];
}
